import React, { useEffect, useRef, useState } from "react";
import mqtt from "mqtt";
import { MqttContext } from "./MqttContext";
const API_URL = process.env.REACT_APP_API_URL;
export const MqttProvider = ({ children }) => {
  const clientRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [messages, setMessages] = useState({}); // topic → last message

  useEffect(() => {
    if (clientRef.current) return; // 🚫 prevent double connect
    const client = mqtt.connect("wss://broker.hivemq.com:8884/mqtt", {
      clientId: `web_${Math.random().toString(16).slice(2)}`,
      clean: true,
      keepalive: 60,
      connectTimeout: 4000,
      protocol: "wss",
      reconnectPeriod: 30000,
    });

    clientRef.current = client;

    client.on("connect", () => {
      console.log("✅ MQTT Connected");
      setIsConnected(true);
      setTimeout(() => {
        subscribe(`dssp/deviceData/#`);
      }, 1000);
    });

    client.on("reconnect", () => {
      console.log("🔄 MQTT Reconnecting...");
    });

    client.on("close", () => {
      console.log("❌ MQTT Closed");
      setIsConnected(false);
    });

    client.on("error", (err) => {
      console.error("MQTT Error:", err);
    });

    client.on("message", (topic, message) => {
  
      let data;

      try {
        data = JSON.parse(JSON.stringify(message?.toString()));
        console.log("✅ JSON object:", data);
        const data2 = JSON.parse(message.toString());

        fetch(`${API_URL}/index.php`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data2),
        })
          .then((response) => response.json())
          .then((responseData) => {
          //  console.log(responseData);
          })
          .catch((e) => {
            console.log(e, "%%%%%%%");
          });
      } catch (e) {
        console.log("❌ Plain text:", JSON.stringify(message?.toString()));
      }
      //   setMessages(prev => ({
      //     ...prev,
      //     [topic]: message.toString(),
      //   }));
      setMessages(message.toString());
    });

    return () => {
      client.end(true);
    };
  }, []);

  // 🔔 Subscribe once
  const subscribe = (topic) => {
    if (!clientRef.current) return;
    clientRef.current.subscribe(topic, { qos: 2 }, (err) => {
      if (!err){
      // console.log("📡 Subscribed:", topic);
      }
    });
  };

  // 🚀 Publish from anywhere
  const publish = (topic, payload, options = {}) => {
    if (!clientRef.current) return;
    clientRef.current.publish(topic, payload, options);
  };

  return (
    <MqttContext.Provider
      value={{
        client: clientRef.current,
        isConnected,
        subscribe,
        publish,
        messages,
      }}
    >
      {children}
    </MqttContext.Provider>
  );
};
